import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getFormName } from '../../utils/nameFormat';
const productForm = getFormName('Product');
export const removeInsideFormStmtInstruction = `
#### Remove Repeater form
- Syntax: \`remove repeater form <repeater_element_name>-><inside_form_name> in <form_name>;\`
- Example: \`remove repeater form options in ${productForm};\`
- Example: \`remove repeater form variants in ${productForm};\`

#### Remove Select create form
- Syntax: \`remove select form <select_element_name>-><inside_form_name> in <form_name>;\`
- Example: \`remove select form options in ${productForm};\`
- Example: \`remove select form variants in ${productForm};\`
`;
export const removeInsideFormHandler = createStructureStatementHandler({
    type: 'remove inside form',
    parse: line => {
        const match = /^remove (repeater|select) form (?<fieldName>\w+) in (?<formName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove inside form',
                fieldName: match.groups.fieldName,
                formName: match.groups.formName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.removeCreateForm({ formName: stmt.formName, fieldName: stmt.fieldName });
        });
    },
});
//# sourceMappingURL=RemoveInsideFormStmt.js.map